import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface ComponentArgs {
  title: string;
  changeset: any;
  property: string;
  onSaved: () => void;
  onCancel: () => void;
}

export default class BalanceAdjustmentEditModalComponent extends Component<ComponentArgs> {
  @tracked saving = false;
  @tracked error?: any;
  @tracked showValidationErrors = false;

  @action
  async save() {
    this.saving = true;
    this.error = undefined;
    this.showValidationErrors = false;
    try {
      let { changeset } = this.args;
      await changeset.validate();
      if (changeset.get('isValid')) {
        await changeset.save();
        this.saving = false;
        this.args.onSaved();
      } else {
        this.showValidationErrors = true;
      }
    } catch (error) {
      this.error = error;
    }
    this.saving = false;
  }
}
